import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-download-destinations-field',
  templateUrl: './list-download-destinations-field.component.html',
  styleUrls: ['./list-download-destinations-field.component.scss']
})
export class ListDownloadDestinationsFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
